const dexfProdKeys = {
	VIMLE: '9ad503c0-6e27-47f5-b6e4-c255d0a62b00',
	FINNALA: 'c08c84b5-acbd-4a2e-a48d-d87ed2f9a9f5',
	GRONLID: 'f8586d41-ac30-49bf-8596-50085e19a3df',
	HARLANDA: '46343e90-7503-446e-b31c-a3bca88b9ceb',
	SODERHAMN: 'f2c45620-67f9-414a-ad45-bc95f2ca7f0d',
	JATTEBO: 'faaea020-d992-4ffc-94de-5c4103862717',
	KIVIK: '8730c155-d946-4350-9db6-ec4d45677394',
};

const dexfQaKey = '829e294e-1e25-4f81-975e-ad53ac4a3682';

export const getDexfApiKey = (appId: string, isProduction: boolean): string => {
	return isProduction ? dexfProdKeys[appId] || '' : dexfQaKey;
};
